import missionBg from "@/assets/mission-bg.jpg";

const MissionSection = () => {
  return (
    <section 
      className="py-20 text-primary-foreground relative bg-cover bg-center"
      style={{ backgroundImage: `url(${missionBg})` }}
    >
      <div className="absolute inset-0 bg-black/40" />
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-6 animate-fade-in">Our Mission</h2>
          <p className="text-lg leading-relaxed animate-fade-in" style={{ animationDelay: "0.2s" }}>
            <span className="font-semibold">Empowering Connections:</span> At Referral Connection Network, our mission is to foster a vibrant community where businesses can thrive through collaboration and shared resources. We aim to empower our members by providing a supportive environment that encourages growth, success, and meaningful connections. Join us in our journey to connect, collaborate, and succeed together.
          </p>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
